export const formError: {[key: string]: string} = {
  'EXCA0004': 'invalidCode',
  'EXCA0002': 'expiredCode'
}
